import { render, staticRenderFns } from "./EmptyAddCard.vue?vue&type=template&id=86c7f9ce"
import script from "./EmptyAddCard.vue?vue&type=script&lang=js"
export * from "./EmptyAddCard.vue?vue&type=script&lang=js"
import style0 from "./EmptyAddCard.vue?vue&type=style&index=0&id=86c7f9ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports